import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			gcTime: 1000 * 60 * 60 * 24, // 24 hours (garbage collection)
			staleTime: 1000 * 60 * 5, // 5 minutes (web-appropriate)
			refetchOnWindowFocus: false,
			refetchOnReconnect: true,
			retry: 1,
		},
		mutations: {
			retry: 0,
		},
	},
});
